import {
    get, getExel, getTx, getZip,
    post,
    put,
    // del
} from '@/service/header'


/**
 * 获取队伍列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getTeamsList (data) {
    return get('/master/match/teams/selectAll',data)
}
/**
 * 新增队伍信息
 * @param data
 * @returns {Promise<unknown>}
 */
export function postTeamsList (data) {
    return post('/master/match/teams/addInfo',data)
}


/**
 * 更新队伍信息
 * @param data
 * @returns {Promise<unknown>}
 */
export function putTeamsList (data) {
    return put('/master/match/teams/updInfo',data)
}

/**
 * 分配线路
 * @param data
 * @returns {Promise<unknown>}
 */
export function allocateRoutes (data) {
    return put('/master/match/teams/allocateRoutes',data)
}

/**
 * 删除队伍信息
 * @param data
 * @returns {Promise<unknown>}
 */
export function delTeamsList (data) {
    return put('/master/match/teams/delInfo',data)
}





/**
 * 获取设置报名信息页面信息
 * @returns {Promise<unknown>}
 * @param matchId
 */
export function getApplyList (matchId) {
    return get('/master/match/dynamic/fields/selectAll/'+matchId)
}
/**
 * 新增报名信息字段
 * @param data
 * @returns {Promise<unknown>}
 */
export function postApplyList (data) {
    return post('/master/match/dynamic/fields/addInfo',data)
}


/**
 * 更新报名信息字段
 * @param data
 * @returns {Promise<unknown>}
 */
export function putApplyList (data) {
    return put('/master/match/dynamic/fields/updInfo',data)
}

/**
 * 删除报名信息字段
 * @param data
 * @returns {Promise<unknown>}
 */
export function delApplyList (data) {
    return put('/master/match/dynamic/fields/delInfo',data)
}








/**
 * 获取队员信息列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getMemberInfoList (teamsId) {
    return get('/master/match/team/member/selectAll?teamsId='+teamsId)
}

/**
 * 获取动态字段表头信息
 * @param data
 * @returns {Promise<unknown>}
 */
export function getHeaders (data) {
    return get('/master/match/team/member/getHeaders',data)
}


/**
 * 新增队员信息
 * @param data
 * @returns {Promise<unknown>}
 */
export function addInfoFieldName (matchId,teamsId,data) {
    return post('/master/match/team/member/addInfo?matchId='+matchId + '&teamsId='+teamsId,data)
}



/**
 * 导出报名信息模板
 * @returns {Promise<unknown>}
 * @param matchId
 */
export function exportExcelApply(matchId,data) {
    return getExel('/master/match/team/member/exportExcelTemplate?matchId='+matchId,data)
}


/**
 * 导出点位经过的队伍
 * @returns {Promise<unknown>}
 * @param matchId
 */
export function exportPositionTeams(matchId,data) {
    return getExel('/master/match/point/position/exportPositionTeams/'+matchId,data)
}

/**
 * 导出点位列表
 * @returns {Promise<unknown>}
 * @param matchId
 */
export function exportPosition(matchId,data) {
    return getExel('/master/match/point/position/exportPosition/'+matchId,data)
}

/**
 * 导入点位列表
 * @returns {Promise<unknown>}
 * @param matchId
 */
export function postExportPosition (matchId,file) {
    return post('/master/match/point/position/importPositionExcel?matchId='+matchId,file)
}


/**
 * 导入报名信息
 * @returns {Promise<unknown>}
 * @param matchId
 */
export function importExcelApply (matchId,groupsId,file) {
    return post('/master/match/team/member/importExcel?matchId='+matchId+'&groupsId='+groupsId,file)
}



/**
 * 下载队伍二维码
 * @returns {Promise<unknown>}
 * @param teamsId 队伍id
 */
export function exportExcelTemplate(teamsId) {
    return getZip('/master/match/team/member/downloadQrCodeImageZip/'+teamsId)
}


/**
 * 下载分销商二维码
 * @returns {Promise<unknown>}
 * @param matchId
 */
export function downloadDistributorZips(matchId) {
    return getZip('/master/match/distributor/downloadDistributorZip/'+matchId)
}

/**
 * 下载队伍号码布
 * @returns {Promise<unknown>}
 * @param teamsId 队伍id
 */
export function downloadNumberClothImageZip(teamsId) {
    return getZip('/master/match/team/member/downloadNumberClothImageZip/'+teamsId)
}

/**
 * 获取邀请码列表
 * @returns {Promise<unknown>}
 * @param data
 */
export function getInvitationCodeApi (data) {
    return get('/master/match/invitation/code/selectAll',data)
}
export function getInvitationCodeApiDingDan (id, data) {
    return get('/master/match/order/selectAll/' + id, data)
}

/**
 * 取消队伍线路分配
 * @returns {Promise<unknown>}
 * @param id 队伍id
 */
export function cancelAllocation (id) {
    return put('/master/match/teams/cancelAllocation?id='+id)
}

/**
 * 订单退款查询
 * @returns {Promise<unknown>}
 * @param data
 */
export function paymentRefundQuery (data) {
    return post('/master/match/order/paymentRefundQuery',data)
}
/**
 * 订单退款
 * @returns {Promise<unknown>}
 * @param data
 */
export function paymentRefund (data) {
    return post('/master/match/order/paymentRefund',data)
}



export function getInvitationNewCodeApi (matchId){
    return get('/master/match/invitation/code/getCode/' + matchId )
}

export function postInvitationAddNewApi (data) {
    return post('/master/match/invitation/code/addInfo', data)
}

//批量生成邀请码
export function postInvitationCode (matchId,number,expirationTime) {
    return post('/master/match/invitation/code/addList?matchId='+matchId+'&number='+number+'&expirationTime='+expirationTime)
}

//获取腾讯位置
export function getTxDingWeiApi (data) {
    return getTx('/ws/geocoder/v1', data)
}
//搜索位置
export function getTxSouSuoApi (data) {
    return getTx('/ws/place/v1/suggestion', data)
}

//获取队伍选择列表
export function getKanBanTeamsApi (id) {
    return get('/master/real/time/kanBan/selectTeams/' + id)
}

//获取线路选择列表
export function getKanBanLinesApi (id) {
    return get('/master/real/time/kanBan/selectLines/' + id)
}

//获取线路数据
export function getKanBanLineIndicatorsApi (id, data) {
    return get('/master/real/time/kanBan/selectLineIndicators/' + id, data)
}

//获取前三名完赛队伍
export function getKanBanFinishSteamApi (id) {
    return get('/master/real/time/kanBan/selectFinishQSTeam/' + id)
}

//获取整体指标数据
export function getKanBanOverallIndicatorsApi (id) {
    return get('/master/real/time/kanBan/selectOverallIndicators/' + id)
}

//获取单个赛事项目数据
export function getSaiShiDanGeApi (id) {
    return get('/master/match/management/selectById/' + id)
}

//获取站点指标
export function getSelectSiteIndicatorsApi (id) {
    return get('/master/real/time/kanBan/selectSiteIndicators/' + id)
}

//获取年龄
export function getSelectNumBerOfAgeApi (id) {
    return get('/master/real/time/kanBan/selectNumberOfAge/' + id)
}

//获取性别比例
export function getSelectNumberOfSexApi (id) {
    return get('/master/real/time/kanBan/selectNumberOfSex/' + id)
}

//获取来源比例
export function getSelectNumberOfLYApi (id) {
    return get('/master/real/time/kanBan/selectNumberOfSource/' + id)
}

//获取参赛次数
export function getSelectNumberOfMatchApi (id) {
    return get('/master/real/time/kanBan/selectNumberOfMatch/' + id)
}

//设置队伍状态
export function putUpdateTeamsStatusApi (data) {
    return put('/master/real/time/kanBan/updateTeamsStatus', data)
}

//队伍打卡所选点位
export function postTeamCheckIn (data) {
    return post('/master/real/time/kanBan/teamCheckIn', data)
}

//zubie
export function getTeamSetUpApi (data) {
    return get('/master/match/groups/selectForTeamSetUp', data)
}

//设置队伍
export function postSetTeamApi (id, data) {
    return post('/master/match/groups/allocateRoutesFromGroups?linesId=' + id, data)
}

//获取队伍打卡明细
export function getClockAllApi (id, data) {
    return get('/master/match/location/push/clock/selectAll/' + id, data)
}

//下载队伍打卡明细
export function getExportExcoleApi (id, list) {
    return getExel('/master/match/location/push/clock/exportToExcel/' + id, list)
}

//获取分销商
export function getDistributorApi (data) {
    return get('/master/match/distributor/selectAll', data)
}

//新增分销商
export function postDistributorApi (data) {
    return post('/master/match/distributor/addInfo', data)
}

//修改分销商
export function putDistributorApi (data) {
    return put('/master/match/distributor/updInfo', data)
}

//删除分销商
export function putDistributorRemoveApi (data) {
    return put('/master/match/distributor/delInfo', data)
}

//下载完赛证书
export function getWanSaiZhengShuApi(id) {
    return get('/master/match/team/member/downloadCertificateCompletionZip/' + id)
}

//获取开赛方式
export function getKaiSaiApi(id) {
    return get('/master/match/management/selectOpeningMethod/' + id)
}

//设置开赛方式
export function postKaiSaiAddApi (data) {
    return put('/master/match/management/openingMethod', data)
}

//查询单个
export function getSaiShiApiOne (data) {
    return get('/master/match/management/selectById/' + data)
}

//取消打卡
export function getQuXiaoDaKa (data) {
    return post('/master/real/time/kanBan/teamCancelCheckIn', data)
}

//获取点位题目数据
export function getPositionSelectAllApi (data) {
    return get('/master/match/point/position/question/selectAll', data)
}

//新建点位题目
export function postPositionTiMuAddApi (data) {
    return post('/master/match/point/position/question/addInfo', data)
}

//删除点位题目
export function putPositionTiMuEditApi (data) {
    return put('/master/match/point/position/question/delInfo', data)
}

//修改点位题目
export function putPositionEditApi (data) {
    return put('/master/match/point/position/question/updInfo', data)
}

//上移下移题目
export function putPositionUpDownApi (type, id) {
    return put('/master/match/point/position/question/move/' + type + '/' + id)
}

//队员号码布或二维码生成异常提示
export function getTeamsPropmtApi (id) {
    return get('/master/match/teams/generateFailurePrompt/' + id)
}
//获取队员信息
export function getNumberInfo (memberId) {
    return get('/master/match/team/member/selectById/' + memberId)
}

//修改单个队员信息
export function updInfoByIdNumber (data) {
    return put('/master/match/team/member/updInfoById',data)
}


//重新生成队员二维码和号码布
export function postAgainRegenerateApi (data) {
    return put('/master/match/teams/againRegenerate?id=' + data.id)
}


/**
 * 设置队员奖品状态和物流单号
 * @returns {Promise<unknown>}
 * @param data
 */
export function postSetPrizeInfo (data) {
    return post('/master/match/team/member/setPrizeInfo',data)
}

//一键重新生成所有队伍二维码和号码补
export function putAllAgainRegenerateApi (matchId) {
    return put('/master/match/teams/againRegenerateAll?matchId=' + matchId)
}

//获取短信提醒列表
export function getTextMessageApi (id, data) {
    return get('/master/sms/sender/selectAll/' + id, data)
}

//获取短信应发送数量
export function getTextMessageYingApi (id, type) {
    return get('/master/sms/sender/getQuantity/' + id + '/' + type)
}

//发送短信提醒
export function postTextMessagePushApi (data) {
    return post('/master/sms/sender/addInfo', data)
}

//获取队员姓名
export function getFileTextApi (id) {
    return get('/master/sms/sender/selectFailSms/' + id)
}

//获取队员姓名
export function selectProgress (id) {
    return get('/master/real/time/kanBan/selectProgress/' + id)
}

//获取队员姓名
export function teamCertificateCompletion (id) {
    return post('/master/real/time/kanBan/teamCertificateCompletion?teamId=' + id)
}
